import { ReelSequenceData } from "@lib/titan2-slingo/dist/api/model/data/ReelSequenceData";
import { SymbolData } from "@lib/titan2-slingo/dist/api/model/data/SymbolData";
import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { DataObject } from "@lib/titan2/dist/api/core/data/DataObject";
/**
 * ExtendedReelSequenceData.ts
 */
export class ExtendedReelSequenceData extends ReelSequenceData {
    solidifySymbols() {
        super.solidifySymbols();
        this.symbols = this.symbols.map((symbol, index) => {
            if (symbol === null) { // it's a transform symbol
                const id = this.data.getStringArray(SlingoConstants.PROPERTY_SYMBOLS)[index];
                switch (id) {
                    case "SJ":
                        return new SymbolData(new DataObject({ id, type: "SUPER_JOKER" }));
                    case "D":
                        return new SymbolData(new DataObject({ id, type: "DEVIL" }));
                    case "FS":
                        return new SymbolData(new DataObject({ id, type: "FREE_SPIN" }));
                    default:
                        throw new Error("Symbol Not Recognised: " + id);
                }
            }
            else {
                return symbol;
            }
        });
    }
}
//# sourceMappingURL=ExtendedReelSequenceData.js.map